import API from "./api";
import router from "../router";

export default {
  fetchGroups() {
    return API().get(`groups`);
  },
  fetchClusterGroups(id) {
    return API().get(`groups/cluster/${id}`);
  },
  fetchTrainerGroups(id) {
    return API().get(`trainers/${id}/groups`);
  },
  fetchCoordinatorGroups(id) {
    return API().get(`coordinators/${id}/groups`);
  },
  createGroup(props) {
    console.log("create, ", props);

    return API().post("groups", props);
  },
  getOneGroup(id) {
    return API().get(`groups/${id}`);
  },
  updateGroup(props) {
    console.log("update, ", props);
    return API().put(`groups/${router.currentRoute.params.id}`, props);
  },
  updateGroupActive(props) {
    console.log(props);

    return API().put(`groups/${props.id}`, props);
  },
  deleteGroup(id) {
    return API().delete(`groups/${id}`);
  },
  deleteTeacher(teacherId) {
    return API().delete(
      `groups/${router.currentRoute.params.id}/teacher/${teacherId}`
    );
  },
  deleteTempTeacher(teacherId) {
    return API().delete(
      `groups/${router.currentRoute.params.id}/teacher-delink-temp/${teacherId}`
    );
  },
  addTeacher(teacherId) {
    return API().post(
      `groups/${router.currentRoute.params.id}/teacher/${teacherId}`
    );
  },
  deleteTrainer(trainerId) {
    return API().delete(
      `groups/${router.currentRoute.params.id}/trainer/${trainerId}`
    );
  },
  addTrainer(trainerId) {
    return API().post(
      `groups/${router.currentRoute.params.id}/trainer/${trainerId}`
    );
  },
  fetchTeachers() {
    return API().get(`groups/${router.currentRoute.params.id}/teachers`);
  },
  fetchTeachersByID(id) {
    return API().get(`groups/${id}/teachers`);
  },
};
